import $ from 'jquery';

/* ===============================================================
Extra js class
=============================================================== */
class Extra {
    constructor(fromAnotherClass = false) {
        if (!fromAnotherClass) {
            this.$window = $(window);
            this.$document = $(document);
            this.$body = $('body');

            // Cache frequently used selectors
            this.$adminBar = $('#wpadminbar');
            this.$headerMain = $('.irantheme-header-main');
            this.$headerTopbar = $('.irantheme-header-topbar');
            this.$wrapper = $('#irantheme-wrapper');
            this.$goToTop = $('#irantheme-go-to-top');
            this.$returnToTop = $('.irantheme-return-to-top');
            this.$mobileAutoHide = $('.irantheme-navbar-mobile-auto-hide');

            // Throttle variables
            this.scrollTimer = null;
            this.resizeTimer = null;

            this.events();
            this.hideGoToTop();
            this.countNumbersOnScroll();
            this.animateServicesProgress();
            this.tinymceInitContent();
            this.serviceSplitSliderMovement();
            this.scrollSpy();
        }
    }

    events() {
        // Combined scroll events with throttling
        this.$document.on('wheel mousewheel', (e) => {
            const delta =
                e.originalEvent.deltaY || e.originalEvent.wheelDelta || 0;
            if (delta < 0) {
                this.$mobileAutoHide.stop(true, true).slideDown();
            } else if (delta > 0) {
                this.$mobileAutoHide.stop(true, true).slideUp();
            }
        });

        // Touch events
        let startY;
        this.$document.on('touchstart', (e) => {
            startY = e.originalEvent.touches[0].clientY;
        });

        this.$document.on('touchmove', (e) => {
            const currentY = e.originalEvent.touches[0].clientY;
            const deltaY = startY - currentY;

            if (deltaY > 0) {
                this.$mobileAutoHide.stop(true, true).slideUp();
            } else if (deltaY < 0) {
                this.$mobileAutoHide.stop(true, true).slideDown();
            }

            startY = currentY;
        });

        // Scroll position persistence
        this.$window.on('scroll', () => {
            if (!this.$body.hasClass('irantheme-page-builder-inactive')) {
                sessionStorage.scrollTop = this.$window.scrollTop();
            } else {
                sessionStorage.scrollTop = 'undefined';
            }
        });

        // Load event
        this.$window.on('load', () => {
            if (sessionStorage.scrollTop !== 'undefined') {
                this.$window.scrollTop(sessionStorage.scrollTop);
            }

            // Smooth scroll for anchor links
            $('a[href^="#"]')
                .not('a[href="#"]')
                .on('click', (e) => {
                    e.preventDefault();
                    const target = $(e.currentTarget).attr('href');
                    if ($(target).length) {
                        $('html, body')
                            .stop(true, true)
                            .animate(
                                {
                                    scrollTop: $(target).offset().top,
                                },
                                500,
                            );
                    }
                });
        });

        // Initialize various functions
        requestAnimationFrame(() => {
            this.justifiedGalleryLayout();
            this.showcaseFullscreen();
            this.showcaseVideo();
            this.showcaseGoDown();
            this.addActiveToPrevInputs();
            this.TypedAnim();
            this.toggleCommunicationFaqQuestion();
            this.setHeightMiniProfileAvatar();
            this.commentsListOptions();
            this.shareListToggle();
            this.magnificationThumbSectionClickable();
            this.triggerScrollingNavbar();
        });

        // Scroll event for go-to-top button
        this.$window.on('scroll', () => {
            this.hideGoToTop();
        });

        // Debounced resize event
        this.$window.on('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.justifiedGalleryLayout();
                this.setHeightMiniProfileAvatar();
                this.showcaseFullscreen();
            }, 100);
        });
    }

    // Add active class to header or navigation menu-item-link in trigger scrolling
    triggerScrollingNavbar() {
        const sections = $('.irantheme-section');
        const navbarMenu = $(
            '.irantheme-header .menu-item .menu-item-link, .irantheme-navigation .menu-item .menu-item-link',
        );

        const handleScroll = () => {
            const windowOffset = this.$window.scrollTop();

            sections.each((index, element) => {
                const $element = $(element);
                const elementId = $element.attr('id');

                if (elementId) {
                    const elementOffsetTop = $element.offset().top;
                    const elementHeight = $element.outerHeight();
                    const elementOffsetBottom =
                        elementOffsetTop + elementHeight;

                    // Check if section is in viewport
                    if (
                        elementOffsetTop <= windowOffset &&
                        elementOffsetBottom >= windowOffset
                    ) {
                        // Find and activate corresponding nav link
                        navbarMenu.each((navIndex, navElement) => {
                            const $navElement = $(navElement);
                            let navHash = $navElement.attr('href') || '';

                            if (navHash.includes('#')) {
                                navHash = navHash.replace('#', '');

                                if (elementId === navHash) {
                                    navbarMenu.removeClass('active');
                                    $navElement.addClass('active');
                                }
                            }
                        });
                    }
                }
            });
        };

        // Throttled scroll handler
        this.$window.on('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(handleScroll, 50);
        });

        // Initial call
        handleScroll();
    }

    // Options of comments list
    commentsListOptions() {
        $('#button-comments-show-list').on('click', (e) => {
            e.preventDefault();
            $('#comments-fixed-container').stop(true, true).fadeIn(250);
        });

        $('#close-comments-fixed').on('click', (e) => {
            e.preventDefault();
            $('#comments-fixed-container').stop(true, true).fadeOut(250);
        });

        // Check URL for respond parameter
        if (window.location.href.includes('respond')) {
            $('#comments-fixed-container').fadeIn(250);
        }
    }

    setHeightMiniProfileAvatar() {
        const $elements = $(
            '.mini-profile .mini-profile-avatar img, .irantheme-footer-master-gallery-item',
        );
        $elements.each((index, element) => {
            const width = $(element).width();
            $(element).height(width);
        });
    }

    tinymceInitContent() {
        $('.irantheme-tinymce-content *')
            .not('.irantheme-btn-void, .irantheme-tinymce-content-button')
            .each((index, element) => {
                const currentStyle = $(element).attr('style');
                if (currentStyle && currentStyle.includes('background-color')) {
                    $(element).addClass('irantheme-tinymce-bg-radius');
                }
            });
    }

    showcaseGoDown() {
        $('.irantheme-showcase-button-scroll-down-trigger').on('click', (e) => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            let $section = $target.closest('.irantheme-section');

            // Check for slider section
            if ($target.closest('.irantheme-swiper-section-slider').length) {
                $section = $target.closest('.irantheme-swiper-section-slider');
            }

            $target.addClass('active');

            const $nextSection = $section.closest('.irantheme-section').next();
            if ($nextSection.length) {
                $('html, body')
                    .stop(true, true)
                    .animate(
                        {
                            scrollTop: $nextSection.offset().top,
                        },
                        400,
                        () => {
                            $target.removeClass('active');
                        },
                    );
            }
        });
    }

    showcaseFullscreen() {
        const adminBarHeight = this.$adminBar.length
            ? this.$adminBar.height()
            : 0;
        const topbarHeight = this.$headerTopbar.length
            ? this.$headerTopbar.height()
            : 0;
        let holderHeaderFixed = 0;

        // Check header position and visibility
        if (
            this.$headerMain.length &&
            !this.$headerMain.hasClass('irantheme-header-sticky') &&
            !this.$headerMain.hasClass('irantheme-header-fixed') &&
            this.$headerMain.css('display') !== 'none'
        ) {
            holderHeaderFixed = this.$headerMain.height();
        }

        const result = adminBarHeight + holderHeaderFixed + topbarHeight;
        const heightValue = `calc(100vh - ${result}px)`;

        // Set height for showcase sections
        this.$wrapper
            .find('.irantheme-header-main')
            .next('.irantheme-showcase-common-section')
            .find('.irantheme-hero-fullscreen')
            .css('height', heightValue);

        // Set height for slider sections and 404 pages
        $('.irantheme-slider-simple-section .irantheme-hero-fullscreen').css(
            'height',
            heightValue,
        );
    }

    showcaseVideo() {
        $('.irantheme-showcase-video-button-trigger').on('click', (e) => {
            e.preventDefault();
            $('.irantheme-showcase-video-form').fadeIn();
            $('.irantheme-showcase-video-form-play').trigger('play');
        });

        $('.irantheme-showcase-video-form-close').on('click', (e) => {
            e.preventDefault();
            $('.irantheme-showcase-video-form-play').trigger('pause');
            $('.irantheme-showcase-video-form').fadeOut();
        });

        $('.irantheme-showcase-video-form-wrapper').on('click', (e) => {
            if ($(e.target).hasClass('irantheme-showcase-video-form-wrapper')) {
                $('.irantheme-showcase-video-form-play').trigger('pause');
                $('.irantheme-showcase-video-form').fadeOut();
            }
        });
    }

    scrollSpy() {
        $('.irantheme-mouse-down-toggle').on('click', (e) => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const $afterElement = $target.closest('header').next();

            if ($afterElement.length) {
                $('html, body').stop(true, true).animate(
                    {
                        scrollTop: $afterElement.offset().top,
                    },
                    400,
                );

                $target.addClass('active');
                setTimeout(() => {
                    $target.removeClass('active');
                }, 1000);
            }
        });

        this.$goToTop.on('click', (e) => {
            e.preventDefault();
            $('html, body').stop(true, true).animate({ scrollTop: 0 }, 1000);
            $(e.currentTarget).addClass('active');

            setTimeout(() => {
                $(e.currentTarget).removeClass('active');
            }, 1000);
        });

        this.$returnToTop.on('click', (e) => {
            e.preventDefault();
            $('html, body').stop(true, true).animate({ scrollTop: 0 }, 1000);
        });
    }

    // Hide go to top button
    hideGoToTop() {
        if (this.$window.scrollTop() > this.$window.height()) {
            this.$goToTop.stop(true, true).fadeIn(250);
        } else {
            this.$goToTop.stop(true, true).fadeOut(250);
        }
    }

    // Toggle of share list
    shareListToggle() {
        $('#button-share-toggle-list').on('click', (e) => {
            e.preventDefault();
            $('.single-share-list').toggleClass('active');
        });
    }

    // Add active to prev label in comments
    addActiveToPrevInputs() {
        $(document).on('focus', 'textarea, input', (e) => {
            $(`label[for="${e.target.id}"]`).addClass('active');
        });

        $(document).on('blur', 'textarea, input', (e) => {
            $(`label[for="${e.target.id}"]`).removeClass('active');
        });
    }

    // Run typed animation
    TypedAnim() {
        $('.irantheme-content-typed .irantheme-typed-strings').each(
            (index, element) => {
                const $element = $(element);
                let $holderTyped = $element;

                // Find deepest child
                while ($holderTyped.children().length > 0) {
                    $holderTyped = $holderTyped.children();
                }

                const goalText = [$holderTyped.text()];
                $holderTyped.text('').addClass('irantheme-tinymce-slider-text');

                const writeSpeed = $element.data('write-speed') || 100;
                const removeSpeed = $element.data('remove-speed') || 50;
                const sliderDelay = $element.data('slider-delay') || 2000;

                let goalSliderText = [];
                let termIndex = 0;

                if ($element.data('slider-text')) {
                    goalSliderText = $element.data('slider-text').split(',');
                    goalText.push(...goalSliderText);
                }

                const typedWrite = () => {
                    if (termIndex === goalText.length) {
                        termIndex = 0;
                    }

                    let letterIndex = 0;
                    const writerInterval = setInterval(() => {
                        if (letterIndex <= goalText[termIndex].length) {
                            $holderTyped.append(
                                goalText[termIndex].charAt(letterIndex),
                            );
                            letterIndex++;
                        } else {
                            clearInterval(writerInterval);
                            setTimeout(typedRemove, sliderDelay);
                        }
                    }, writeSpeed);
                };

                const typedRemove = () => {
                    let removeText = $holderTyped.text();
                    let letterIndex = removeText.length;

                    const removeInterval = setInterval(() => {
                        removeText = removeText.substr(0, letterIndex - 1);
                        $holderTyped.text(removeText);
                        letterIndex--;

                        if (letterIndex < 0) {
                            clearInterval(removeInterval);
                            termIndex++;
                            typedWrite();
                        }
                    }, removeSpeed);
                };

                typedWrite();
            },
        );
    }

    // Count numbers on scroll
    countNumbersOnScroll() {
        $('.irantheme-section-counter-number-on-scroll').each(
            (index, element) => {
                const $element = $(element);
                const $window = $(window);

                const handleScroll = () => {
                    const elementOffset = $element.offset().top;
                    const windowScrollTop = $window.scrollTop();
                    const windowHeight = $window.height();

                    // Element is in viewport when its top is above the bottom of viewport
                    // and its bottom is below the top of viewport
                    const isInViewport =
                        elementOffset <= windowScrollTop + windowHeight;

                    if (isInViewport) {
                        $window.off(`scroll.counter${index}`);

                        $element
                            .find('.irantheme-number-counter-on-scroll')
                            .each(function () {
                                const $this = $(this);
                                const targetValue =
                                    parseInt($this.data('counter')) || 0;

                                $({ Counter: 0 }).animate(
                                    { Counter: targetValue },
                                    {
                                        duration: 2000,
                                        easing: 'swing',
                                        step: function (now) {
                                            // Use Math.floor for consistent counting up
                                            $this.text(Math.floor(now));
                                        },
                                        complete: function () {
                                            // Ensure the final value is set exactly
                                            $this.text(targetValue);
                                        },
                                    },
                                );
                            });
                    }
                };

                $window.on(`scroll.counter${index}`, handleScroll);
                handleScroll(); // Check on load
            },
        );
    }

    // Complete width of services progress on scroll
    animateServicesProgress() {
        $('.irantheme-service-progress-holder').each((index, element) => {
            const $element = $(element);
            const $window = $(window);

            const handleScroll = () => {
                const elementOffset = $element.offset().top;
                const windowScrollTop = $window.scrollTop();
                const windowHeight = $window.height();

                // Element is in viewport when its top is above the bottom of viewport
                // and its bottom is below the top of viewport
                const isInViewport =
                    elementOffset <= windowScrollTop + windowHeight;

                if (isInViewport) {
                    $window.off(`scroll.progress${index}`);

                    $element
                        .find(
                            '.irantheme-service-progress-item-bar-line-filled.irantheme-animate-filled',
                        )
                        .each(function () {
                            const $this = $(this);
                            const targetWidth = $this.data('width');

                            $({ Width: 0 }).animate(
                                { Width: targetWidth },
                                {
                                    duration: 2000,
                                    easing: 'swing',
                                    step: function () {
                                        $this.css('width', this.Width + '%');
                                    },
                                },
                            );
                        });
                }
            };

            $window.on(`scroll.progress${index}`, handleScroll);
            handleScroll(); // Check on load
        });
    }

    // Animate communication faq toggle
    toggleCommunicationFaqQuestion() {
        $(document).on(
            'click',
            '.irantheme-communication-faq-list-item-question',
            (e) => {
                e.preventDefault();
                const $item = $(e.currentTarget).closest(
                    '.irantheme-communication-faq-list-item',
                );
                const $itemQuestion = $item.find(
                    '.irantheme-communication-faq-list-item-question',
                );
                const $itemAnswer = $item.find(
                    '.irantheme-communication-faq-list-item-answer',
                );

                if ($item.hasClass('active')) {
                    $item.removeClass('active');
                    $itemQuestion.removeClass('active');
                    $itemAnswer.stop(true, true).slideUp(350);
                } else {
                    $item.addClass('active');
                    $itemQuestion.addClass('active');
                    $itemAnswer.stop(true, true).slideDown(350);
                }
            },
        );
    }

    // Gallery thumb image magnification
    magnificationThumbSectionClickable() {
        // Close button
        $(document).on(
            'click',
            '.irantheme-gallery-magnification-slider-action-close',
            (e) => {
                e.preventDefault();
                const $magnifiedHolder = $(e.currentTarget).closest(
                    '.irantheme-gallery-magnification-slider',
                );
                const $videoItems = $magnifiedHolder.find('video');

                $videoItems.each((index, video) => {
                    video.pause();
                });

                $magnifiedHolder.fadeOut('fast');
            },
        );

        // Fullscreen button
        $(document).on(
            'click',
            '.irantheme-gallery-magnification-slider-action-full-screen-toggle',
            (e) => {
                e.preventDefault();
                if (!document.fullscreenElement) {
                    document.documentElement.requestFullscreen();
                } else if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            },
        );

        // Share button
        $(document).on(
            'click',
            '.irantheme-gallery-magnification-slider-action-share',
            (e) => {
                e.preventDefault();
                const $shareHolder = $(e.currentTarget).closest(
                    '.irantheme-gallery-magnification-slider-action-share-holder',
                );
                $shareHolder.toggleClass('irantheme-btn-share-active');
            },
        );

        // Close share dropdown when clicking outside
        $(document).on('click', (e) => {
            if (
                !$(e.target).closest(
                    '.irantheme-gallery-magnification-slider-action-share-holder',
                ).length
            ) {
                $(
                    '.irantheme-gallery-magnification-slider-action-share-holder',
                ).removeClass('irantheme-btn-share-active');
            }
        });
    }

    justifiedGalleryLayout() {
        const $justifiedHolder = $('.irantheme-post-gallery-justified');
        if (!$justifiedHolder.length) return;

        const justifyScale =
            screen.height * ($justifiedHolder.data('height') || 0.4);
        const $galleryItems = $justifiedHolder.find(
            '.irantheme-post-gallery-item',
        );

        $galleryItems.each((index, element) => {
            const $element = $(element);
            const $image = $element.find('img');
            const $video = $element.find('video');

            if ($image.length) {
                $image
                    .one('load', function () {
                        const ratio = this.naturalWidth / this.naturalHeight;
                        $element.css({
                            width: `${justifyScale * ratio}px`,
                            'flex-grow': ratio,
                        });
                    })
                    .each(function () {
                        if (this.complete) $(this).trigger('load');
                    });
            }

            if ($video.length) {
                $video
                    .one('loadedmetadata', function () {
                        const ratio = this.videoWidth / this.videoHeight;
                        $element.css({
                            width: `${justifyScale * ratio}px`,
                            'flex-grow': ratio,
                        });
                    })
                    .each(function () {
                        if (this.readyState >= 1)
                            $(this).trigger('loadedmetadata');
                    });
            }
        });
    }

    // Related to section service split slider
    serviceSplitSliderMovement() {
        $('#slider').on('input change', (e) => {
            const sliderPos = e.target.value;
            $('.foreground-img').css('width', `${sliderPos}%`);
            $('.slider-button').css('left', `calc(${sliderPos}% - 18px)`);
        });
    }
}

export default Extra;
